export const MAX_IMAGE_FILE_SIZE = 500 * 1024;
export const MAX_SWITCH_IN_NON_GIF_IMAGE_FILE_SIZE = 80 * 1024;
export const MAX_SWITCH_IN_ANIMATED_IMAGE_FILE_SIZE = 800 * 1024;
export const MAX_VIDEO_FILE_SIZE = 500 * 1024 * 1024; // 500MB
export const CONTENT_PACKAGE_NONE_ELEMENT_ID = '0';
export const DEFAULT_CREATIVES_QUANTITY = 1;
export const MIN_NUMBER_OF_CREATIVES = 1;
export const MAX_NUMBER_OF_CREATIVES = 50;
export const MIN_BONUS_IMPRESSIONS_VALUE = 1000;
